<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Percentage Worn Calculation </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="ttmodal__body about-modal">
    <div class="checkbox-group">
  <mat-checkbox
    [(ngModel)]="worstComponent"
    (change)="onWorstComponentChange()">
    Worst Component
  </mat-checkbox>

  <mat-checkbox
    [(ngModel)]="averagePercent"
    (change)="onAveragePercentChange()">
    Average % Worn
  </mat-checkbox>
</div>

<div class="component-list">
  <mat-checkbox class="component-item"
    *ngFor="let item of EquipmentCompartmentTypeModel"
    [(ngModel)]="item.IsSelected"
    [disabled]="!averagePercent"
    (change)="onComponentChange(item.CompartTypeId, $event.checked)">
    {{ item.CompartTypeName }}
  </mat-checkbox>
</div>
  </div>
  <div class="ttmodal__footer ok-button" >
   <button mat-raised-button class="margin" (click)="onNoClick()"> {{ 'Cancel' | translate | async }}</button>
   <button mat-raised-button color="warn"   (click)="savePercentWornPreference()"><span class="material-icons button__icon">check</span><span class="button__text">{{ 'Save' | translate | async }} </span></button>
  </div>
</div>